import React from 'react'

export default function FaceFeature({ scaleX, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} style={{ opacity: 0.2 }}>
      <path
        d="M0.749969 0.191895C1.05997 0.931895 1.21999 1.68187 1.32999 2.42188C1.44999 3.16188 1.48997 3.91186 1.49997 4.65186C1.49997 5.39186 1.45 6.14184 1.34 6.88184C1.23 7.62184 1.06997 8.37182 0.749969 9.11182C0.439969 8.37182 0.270004 7.62184 0.160004 6.88184C0.0400037 6.14184 0 5.39186 0 4.65186C0 3.91186 0.0499829 3.16188 0.169983 2.42188C0.279983 1.67188 0.439969 0.931895 0.749969 0.191895Z"
        fill={outline}
      />
    </g>
  )
}
